import { render, staticRenderFns } from "./integration-view.vue?vue&type=template&id=079fc853&"
import script from "./integration-view.vue?vue&type=script&lang=js&"
export * from "./integration-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports